import React, { useEffect, useState } from "react";
import api from "../../config/axios";
import ReservationForm from "./ReservationForm";
import "./TableMap.css";
import Header from "../common/Header";
import { useNavigate } from "react-router-dom";

interface Table {
  _id: string;
  name: string;
  seats: number;
  status: "available" | "reserved" | "in-use";
}

interface TableMapProps {
  user: { username: string; role: string };
  onLogout: () => void;
}

const TableMap: React.FC<TableMapProps> = ({ user, onLogout }) => {
  const [tables, setTables] = useState<Table[]>([]);
  const [selectedTable, setSelectedTable] = useState<Table | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/api/tables").then(res => setTables(res.data));
  }, []);

  return (
    <div>
      <Header user={user} onLogout={onLogout}/>
      <div className="table-map-container">
        <div className="tablemap-header">
        <button className="employee-back-btn" onClick={() => navigate(-1)} title="Quay lại">
          ←
        </button>
        <h2 className="tablemap-title">SƠ ĐỒ BÀN</h2>
      </div>
      <div className="tablemap-legend" style={{ display: 'flex', gap: 18, marginBottom: 12 }}>
        <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <span className="legend-icon available"></span> <span>Trống</span>
        </span>
        <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <span className="legend-icon reserved"></span> <span>Đã đặt</span>
        </span>
        <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <span className="legend-icon in-use"></span> <span>Đang sử dụng</span>
        </span>
      </div>
      <div className="table-map">
        {tables.map(table => (
          <div
            key={table._id}
            className={`table-item ${table.status}`}
            onClick={() => table.status === "available" && setSelectedTable(table)}
            style={{ cursor: table.status === "available" ? "default" : "not-allowed" }}
          >
            {table.name}
            <br />
            <span>{table.seats} ghế</span>
          </div>
        ))}
        </div>
      </div>
      {selectedTable && (
        <>
          <div className="reservation-modal-overlay" onClick={() => setSelectedTable(null)} />
          <div className="reservation-modal">
            <ReservationForm
              table={selectedTable}
              onClose={() => setSelectedTable(null)}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default TableMap;
